var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-left align-center fill-height"},[_c('EqsTabs',_vm._b({attrs:{"value":_vm.tab,"data-type":"default"},on:{"update:value":function($event){_vm.tab=$event}},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c(item.is,{tag:"component"})]}}])},'EqsTabs',{ tabs: _vm.tabs },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }